import { render, staticRenderFns } from "./TableActionModal.vue?vue&type=template&id=523da73e&scoped=true&"
import script from "./TableActionModal.vue?vue&type=script&lang=js&"
export * from "./TableActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523da73e",
  null
  
)

export default component.exports